import { ButtonProps } from "@mui/material";
import VidletButton from "./VidletButton";

export default function DeleteButton({ children, sx, ...props }: ButtonProps) {
  return (
    <VidletButton
      sx={{
        backgroundColor: "#c70505",
        "&:hover": {
          backgroundColor: "#ea0606",
        },
        ...sx,
      }}
      {...props}
    >
      {children || "DELETE"}
    </VidletButton>
  );
}
